<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-8">
        <h1 class="page-header">Granska och skicka in din registrering (steg 3 av 3)</h1>
        <p>Granska uppgifterna och skicka in registreringen. </p>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-4 form-background-color">
        <div class="p-4 h-100">
          <h2 class="h4">Organisationsuppgifter</h2>
          <div class="mt-4">
            <h3 class="h5"><b>Organisationsnummer</b></h3>
            <p>{{ state.organisation.organisationNumber }}</p>
            <p class="bold">{{ state.organisation.displayName }}</p>
            <template
              v-if="
                  state.organisation.addressList &&
                  state.organisation.addressList?.length > 0
                "
            >
              <p>
                {{ state.organisation.addressList[0].streetAddress }}
              </p>
              <p>
                {{ state.organisation.addressList[0].postalCode }}
                {{ state.organisation.addressList[0].locality }}
              </p>
            </template>
            <p>{{ state.organisation.phoneNumber }}</p>
          </div>
        </div>
      </div>
      <div class="col-4 form-background-color">
        <div class="p-4 h-100">
          <h2 class="h4">Huvudkontakt</h2>
          <div class="mt-4">
            <h3 class="h5"><b>Namn</b></h3>
            {{
              state.organisation.contactInfoList &&
              state.organisation.contactInfoList[0]?.firstName
            }}
            {{
              state.organisation.contactInfoList &&
              state.organisation.contactInfoList[0]?.lastName
            }}
          </div>
          <h3 class="h5"><b>E-post</b></h3>
          <p>
            {{
              state.organisation.contactInfoList &&
              state.organisation.contactInfoList[0]?.email
            }}
          </p>
          <h3 class="h5"><b>Telefon</b></h3>
          <p>
            {{
              state.organisation.contactInfoList &&
              state.organisation.contactInfoList[0]?.phone
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container mt-4">
    <div class="row">
      <div class="col-8">
        <CtaPanel>
          <div class="buttons-container spread-buttons">
            <PreviousNavLink go-to-link="/"
                             previous-label="Avbryt"></PreviousNavLink>
            <button
              :disabled="state.loading"
              class="btn btn-light ml-3"
              @click="register()"
            >
              Skicka in registrering <span class="far fa-paper-plane"></span>
            </button>
          </div>
        </CtaPanel>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from "@vue/runtime-core";
import { useOrganisationStore } from "@/stores/organisation";
import CtaPanel from "../components/CtaPanel.vue";
import { useRouter } from "vue-router";
import { useToastStore } from "@/stores/toast";
import { useUserStore } from "@/stores/user";
import { ContactInfoModel } from "@Shared/Models/ContactInfoModel";
import { OrganisationModel } from "@Shared/Models/OrganisationModel";
import PreviousNavLink from "@/components/PreviousNavLink.vue";

export default defineComponent({
  name: "RegistrationFormSummary",
  components: {
    CtaPanel,
    PreviousNavLink
  },
  setup() {
    const organisationStore = useOrganisationStore();
    const toastStore = useToastStore();
    const router = useRouter();
    const userStore = useUserStore();

    const state = reactive({
      loading: false,
      user: {} as ContactInfoModel,
      organisation: {} as OrganisationModel
    });

    state.user = userStore.getUser();
    if (!state.user.email.length) {
      state.user = state.user = JSON.parse(sessionStorage.getItem("user") as string);
    }

    state.organisation = organisationStore.organisation;
    if (state.organisation.displayName.length < 1) {
      state.organisation = JSON.parse(sessionStorage.getItem("organisation") as string);
    }


    const register = async () => {
      state.loading = true;
      const result = await organisationStore.Register(state.organisation);
      if (result) {
        await organisationStore.GetOrganisations();
        organisationStore.setDefaultOrganisation();
        state.loading = false;
        sessionStorage.removeItem("organisation");
        sessionStorage.removeItem("user");
        await router.push("tack");
      } else {
        state.loading = false;
        toastStore.addToast({
          message: "Något gick fel",
          toastType: "danger"
        });
        console.error("Error: " + result);
      }
    };

    return {
      state,
      register
    };
  }
});
</script>

<style lang="scss" scoped>
</style>
